// extracted by mini-css-extract-plugin
export default {"container":"SinglePlaceFormArea_container__3+5Bl","hidden":"SinglePlaceFormArea_hidden__N1zkE"};